import * as Yup from 'yup';
import { TemplateFormFieldValidation } from '../../interfaces/template-form';

export function RequiredValidation(
  validator: Yup.Schema<unknown>,
  validation: TemplateFormFieldValidation
) {
  const { errorMessage } = validation;

  return (validator as Yup.MixedSchema).required(errorMessage);
}
